import axiosInstance from './axiosConfig'
const store = require('./store').default

const getMessage = (itemMessage) => {
  if (itemMessage === null || itemMessage === undefined) return ''
  const text = String(itemMessage).trim()
  return text ? ` ${text}` : ''
}

const getResponseMessage = (data) => {
  if (!data) return ''
  if (typeof data === 'string') return data
  if (typeof data.message === 'string' && data.message.trim()) return data.message
  if (Array.isArray(data) && typeof data[0]?.message === 'string' && data[0].message.trim()) return data[0].message
  return ''
}

const get = async (route, params = {}) => {
  const result = await axiosInstance
    .get(route, params)
    .then((res) => {
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      return { error: true, ...err.response, status: err.response?.status }
    })

  return result
}

const search = async (route, objectParams) => {
  const result = await axiosInstance
    .get(route, { params: objectParams })
    .then((res) => {
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      return { error: true, ...err.response, status: err.response?.status }
    })
  return result
}

const insert = async (route, object, itemMessage) => {
  const message = getMessage(itemMessage)
  let headers = {}
  for (let key in object) {
    if (object[key] instanceof File) {
      headers = { 'Content-Type': 'multipart/form-data' }
    }
  }
  const result = await axiosInstance
    .post(route, object, {
      headers: headers,
    })
    .then((res) => {
      const backendMessage = getResponseMessage(res.data)
      store.dispatch('setSuccess', {
        message: backendMessage || `Sucesso ao cadastrar${message}!`,
      })
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      const backendMessage = getResponseMessage(err.response?.data)
      store.dispatch('setError', {
        message: backendMessage || `Erro ao cadastrar${message}!`,
      })

      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const update = async (route, id, object, itemMessage) => {
  const message = getMessage(itemMessage)
  const result = await axiosInstance
    .patch(`/${route}/${id}`, object)
    .then((res) => {
      const backendMessage = getResponseMessage(res.data)
      store.dispatch('setSuccess', {
        message: backendMessage || `Sucesso ao atualizar${message}!`,
      })
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      const backendMessage = getResponseMessage(err.response?.data)
      store.dispatch('setError', {
        message: backendMessage || `Erro ao atualizar${message}!`,
      })
      return { error: true, ...err.response, status: err.response?.status }
    })
  return result
}

const remove = async (route, id, itemMessage) => {
  const result = await axiosInstance
    .delete(`/${route}/${id}`)
    .then((res) => {
      store.dispatch('setSuccess', {
        message: `Sucesso ao remover ${itemMessage}!`,
      })

      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      console.log(err)

      store.dispatch('setError', {
        message: err.response?.data?.[0]?.message || `Erro ao remover ${itemMessage}!`,
      })

      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const batchRemove = async (route, itemsArray, itemMessage) => {
  try {
    const result = await axiosInstance
      .delete(`/${route}/batch-remove`, { data: { items: itemsArray } })
      .then((res) => {
        store.dispatch('setSuccess', {
          message: `Sucesso ao remover ${itemMessage}!`,
        })

        return { ...res.data, status: res.status }
      })
      .catch((err) => {
        console.log(err)

        store.dispatch('setError', {
          message: `Erro ao remover ${itemMessage}!`,
        })

        return { error: true, ...err.response.data, status: err.response.status }
      })

    return result
  } catch (error) {
    console.log(error)
    store.dispatch('setError', {
      message: `Erro ao remover ${itemMessage}!`,
    })

    return { error: true, message: error.message, status: 500 }
  }
}

const validateCurrentPassword = async (route, object) => {
  const result = await axiosInstance
    .post(route, object)
    .then((res) => {
      return res
    })
    .catch((err) => {
      return err
    })
  return result
}

const insertFile = async (route, object) => {
  const formData = new FormData()

  Object.keys(object).forEach((el) => {
    const value = object[el]
    if (Array.isArray(value)) {
      const hasOnlyFiles = value.length > 0 && value.every((item) => item instanceof File || item instanceof Blob)

      if (hasOnlyFiles) {
        value.forEach((file) => {
          formData.append(el === 'files' ? 'file' : el, file)
        })
      } else {
        formData.append(el, JSON.stringify(value))
      }
    } else if (value !== null && value !== undefined && typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)) {
      formData.append(el, JSON.stringify(value))
    } else if (value !== null && value !== undefined) {
      formData.append(el, value)
    }
  })

  const result = await axiosInstance
    .post(route, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      store.dispatch('setSuccess', {
        message: `Sucesso ao enviar arquivo!`,
      })
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      store.dispatch('setError', {
        message: `Erro ao enviar arquivo!`,
      })
      return { error: true, ...err.response, status: err.response.status }
    })
  return result
}

const getFile = async (params, fileName, headers, action, route = 'exporter/xlsx', content = null, includeDeleted = false) => {
  const result = await axiosInstance
    .post(
      route,
      { ...params, headers, action, content, includeDeleted },
      {
        responseType: 'blob',
      },
    )
    .then((res) => {
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', `${fileName}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      return { ...res.data, status: res.status }
    })
    .catch((err) => {
      store.dispatch('setError', {
        message: `Erro ao baixar arquivo ${err.response?.message}!`,
      })
      return { error: true, error: err, status: err.response?.status }
    })

  return result
}

export { get, search, update, remove, batchRemove, insert, validateCurrentPassword, insertFile, getFile }
